import React, { useState, useEffect, useContext } from "react";
import { ReactReduxContext, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  removeFromCart,
  updateCart,
  cartFetch,
  clearCartData,
  addFreeToCart
} from "../../features/cartSlice";
import Carttitle from "../cart/Carttitle";

import Cartitems from "../cart/Cartitems";
import Carttotal from "../cart/Carttotal";

import { useAuth } from "../../hooks/customers/AuthProvider";
import { LoaderContext } from "../utils/Contexts";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";

function Cart() {
  /*const { store } = useContext(ReactReduxContext);
  console.log('store', store.getState());*/
  const cart = useSelector((state) => state.cart.cartData);
  const cartLoad = useSelector((state) => state.cart.loading);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translations = {
    added_to_cart: t("added_to_cart"),
    items_added_to_cart: t("items_added_to_cart"),
    removed_from_cart: t("removed_from_cart"),
    qty_updated_cart: t("qty_updated_cart"),
    cart_cleared: t("cart_cleared")
  };
  const auth = useAuth();
  const customer = auth.customer;
  const customerId = customer._id;
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [cartData, setCartData] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [reloadCart, setReloadCart] = useState(false);
  const [quantities, setQuantities] = useState({});
  const [clearCartPopup, setClearCartPopup] = useState(false);
  const [freeGiftProducts, setFreeGiftProducts] = useState([]);
  const [freeGiftIds, setFreeGiftIds] = useState([]);
  const [freeGiftLoaded, setFreeGiftLoaded] = useState(false);
  const deleteItem = async (e) => {
    setLoader(true);
    dispatch(
      removeFromCart({
        cart_id: cartData._id,
        item_id: e.currentTarget.getAttribute("data-item-id"),
        name: e.currentTarget.getAttribute("data-item-name"),
        product_id: e.currentTarget.getAttribute("data-product-id"),
        translations,
      })
    );
    setTimeout(() => {
      dispatch(cartFetch());
      setLoader(false);
    }, 2000);
  };

  const updateItem = async (qty, itemId, name, product_id) => {
    setLoader(true);
    if (qty <= 0) {
      dispatch(
        removeFromCart({
          cart_id: cartData._id,
          item_id: itemId,
          name: name,
          product_id: product_id,
          translations,
        })
      );
    } else {
      dispatch(
        updateCart({
          cart_id: cartData._id,
          item_id: itemId,
          qty: qty,
          name: name,
          product_id: product_id,
          translations,
        })
      );

    }

    setTimeout(() => {
      dispatch(cartFetch());
      setLoader(false);
      setReloadCart(true);
    }, 1500);
  };

  useEffect(() => {
    if (reloadCart && !cartLoad) {
      dispatch(cartFetch());
      setReloadCart(false);
    }
  }, [reloadCart, cartLoad]);

  useEffect(() => {
    const getFreeGiftProducts = async () => {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const response = await API.get(`${ENDPOINTS.GET_FREE_GIFT_PRODUCTS}/?start_date=${today}&end_date=${today}`);
        if (response.statusText === "OK") {
          const apiData = response.data.data?.data || response.data.data || response.data;
          setFreeGiftProducts(apiData);
        }
      } catch (error) {
        console.error("Error fetching free gift products:", error);
      } finally {
        setFreeGiftLoaded(true);
      }
    };

    getFreeGiftProducts();
  }, []);

  useEffect(() => {
    if (cart?.cart) {
      setCartData(cart?.cart);
      setCartItems(cart?.items);
      const initialQuantities = {};
      cart?.items.forEach((item) => {
        initialQuantities[item._id] = item.quantity;
      });
      setQuantities(initialQuantities);
    } else if (cart === null || !cart?.cart || cart?.items?.length <= 0) {
      setCartData({});
      setCartItems([]);
    } else {
      dispatch(cartFetch());
    }
  }, [cart]);

  useEffect(() => {
    setIsDataLoaded(!cartLoad);
  }, [cartLoad]);

  // useEffect(() => {
  //   // Automatically add or remove unlocked free gifts based on subtotal
  //   if (cartData?._id && typeof cartData?.subtotal !== 'undefined' && freeGiftProducts?.length > 0) {
  //     const currentSubtotal = parseFloat(cartData.subtotal) || 0;

  //     // Determine free gifts that should be added (not already in cart)
  //     const freeGiftsToAdd = freeGiftProducts.filter((gift) => {
  //       const orderAmount = parseFloat(gift.order_amount?.$numberDecimal || gift.order_amount || 0);
  //       if (currentSubtotal >= orderAmount) {
  //         const alreadyInCart = cartItems?.some(item => {
  //           const itemProdId = item.product_id?._id || item.product_id;
  //           const giftProdId = gift.product?._id || gift.product_id?._id || gift.product_id || gift.product?.id;
  //           return String(itemProdId) === String(giftProdId) && item.is_free_gift === true;
  //         });
  //         return !alreadyInCart;
  //       }
  //       return false;
  //     });

  //     // Determine free gifts that should be removed (in cart but no longer eligible)
  //     const freeGiftsInCart = (cartItems || []).filter(i => i.is_free_gift === true);
  //     const freeGiftsToRemove = freeGiftsInCart.filter((item) => {
  //       // find matching campaign for this free item
  //       const itemProdId = item.product_id?._id || item.product_id;
  //       const campaign = freeGiftProducts.find((gift) => {
  //         const giftProdId = gift.product?._id || gift.product_id?._id || gift.product_id || gift.product?.id;
  //         return String(giftProdId) === String(itemProdId);
  //       });
  //       if (!campaign) {
  //         // If there's no campaign for this item anymore, remove it
  //         return true;
  //       }
  //       const orderAmount = parseFloat(campaign.order_amount?.$numberDecimal || campaign.order_amount || 0);
  //       // If cart subtotal dropped below campaign threshold, remove the free gift
  //       return currentSubtotal < orderAmount;
  //     });

  //     // First remove ineligible free gifts from cart
  //     if (freeGiftsToRemove.length > 0) {
  //       console.log('Removing ineligible free gifts:', freeGiftsToRemove);
  //       freeGiftsToRemove.forEach((item) => {
  //         dispatch(removeFromCart({
  //           cart_id: cartData._id,
  //           item_id: item._id,
  //           name: item.product_name,
  //           product_id: item.product_id?._id || item.product_id,
  //           translations,
  //         }));
  //       });
  //       // After removals, refresh cart after a short delay
  //       setTimeout(() => {
  //         dispatch(cartFetch(customerId));
  //       }, 700);
  //     }

  //     // Then add newly unlocked free gifts
  //     if (freeGiftsToAdd.length > 0) {
  //       console.log('Adding newly unlocked free gifts:', freeGiftsToAdd);
  //       dispatch(addFreeToCart({
  //         cartId: cartData._id,
  //         freeGifts: freeGiftsToAdd,
  //         customer_id: customerId,
  //       }))
  //         .then((result) => {
  //           console.log('Free gifts added successfully:', result);
  //           setTimeout(() => {
  //             dispatch(cartFetch(customerId));
  //           }, 800);
  //         })
  //         .catch((error) => {
  //           console.error('Error adding free gifts:', error);
  //         });
  //     }
  //   }else if(freeGiftProducts?.length == 0){
  //     console.log(11)

  //   }
  // }, [cartData?._id, cartData?.subtotal, freeGiftProducts, freeGiftLoaded,dispatch, customerId]);

  useEffect(() => {
    if (!cartData?._id || !freeGiftLoaded) return;

    const currentSubtotal = parseFloat(cartData?.subtotal) || 0;

    const freeGiftsInCart = (cartItems || []).filter(
      item => item.is_free_gift === true
    );

    // 🚨 CASE 1: No free gift campaigns → remove all free gifts from cart
    if (!freeGiftProducts || freeGiftProducts.length === 0) {
      if (freeGiftsInCart.length > 0) {
        console.log("Removing all free gifts (no active campaigns)");

        freeGiftsInCart.forEach(item => {
          dispatch(removeFromCart({
            cart_id: cartData._id,
            item_id: item._id,
            name: item.product_name,
            product_id: item.product_id?._id || item.product_id,
            translations,
          }));
        });

        setTimeout(() => {
          dispatch(cartFetch(customerId));
        }, 700);
      }
      return; // ⛔ stop further free gift logic
    }

    // ✅ CASE 2: Campaigns exist → normal add/remove logic
    const freeGiftsToAdd = freeGiftProducts.filter(gift => {
      const orderAmount = parseFloat(
        gift.order_amount?.$numberDecimal || gift.order_amount || 0
      );

      if (currentSubtotal >= orderAmount) {
        const alreadyInCart = cartItems?.some(item => {
          const itemProdId = item.product_id?._id || item.product_id;
          const giftProdId =
            gift.product?._id ||
            gift.product_id?._id ||
            gift.product_id;

          return (
            String(itemProdId) === String(giftProdId) &&
            item.is_free_gift === true
          );
        });
        return !alreadyInCart;
      }
      return false;
    });

    const freeGiftsToRemove = freeGiftsInCart.filter(item => {
      const itemProdId = item.product_id?._id || item.product_id;

      const campaign = freeGiftProducts.find(gift => {
        const giftProdId =
          gift.product?._id ||
          gift.product_id?._id ||
          gift.product_id;
        return String(giftProdId) === String(itemProdId);
      });

      if (!campaign) return true;

      const orderAmount = parseFloat(
        campaign.order_amount?.$numberDecimal || campaign.order_amount || 0
      );

      return currentSubtotal < orderAmount;
    });

    if (freeGiftsToRemove.length > 0) {
      freeGiftsToRemove.forEach(item => {
        dispatch(removeFromCart({
          cart_id: cartData._id,
          item_id: item._id,
          name: item.product_name,
          product_id: item.product_id?._id || item.product_id,
          translations,
        }));
      });

      setTimeout(() => {
        dispatch(cartFetch(customerId));
      }, 700);
    }

    if (freeGiftsToAdd.length > 0) {
      dispatch(addFreeToCart({
        cartId: cartData._id,
        freeGifts: freeGiftsToAdd,
        customer_id: customerId,
      })).then(() => {
        setTimeout(() => {
          dispatch(cartFetch(customerId));
        }, 800);
      });
    }

  }, [
    cartData?._id,
    cartData?.subtotal,
    freeGiftProducts,
    freeGiftLoaded,
    cartItems,
    dispatch,
    customerId
  ]);

  const handleClearCart = async (e) => {
    setLoader(true);
    dispatch(
      clearCartData({
        cart_id: cartData._id,
        translations
      })
    );
    setTimeout(() => {
      dispatch(cartFetch());
      setLoader(false);
    }, 1000);
    setClearCartPopup(false);
  };

  const handleCancel = () => {
    setClearCartPopup(false);
  };

  const handleCart = () => {
    setClearCartPopup(true);
  };

  const handleFreeGift = (itemId, isGift) => {
    setFreeGiftIds((prev) => {
      if (isGift) {
        return [...new Set([...prev, itemId])];
      } else {
        return prev.filter((id) => id !== itemId);
      }
    });
  };

  return (
    <div className="favbg">
      <div className="innerwrapper Favourites_search">
        <div className="search_fav">
          <Carttitle onClearCart={handleClearCart} showClearButton={cartItems && cartItems.length > 0}
            handleCancel={handleCancel} handleCart={handleCart} clearCartPopup={clearCartPopup} />
          {cartItems && cartItems.length > 0 && (
            <div className="cartmain">
              <Cartitems
                deleteItem={deleteItem}
                updateItem={updateItem}
                cartLoad={cartLoad}
                cartData={cartData}
                cartItems={cartItems}
                quantities={quantities}
                onFreeGift={handleFreeGift}
                freeGiftProducts={freeGiftProducts}
                onClearCart={handleClearCart}
              />
              <Carttotal
                cartData={cartData}
                cartItems={cartItems}
                customer={customer}
                freeGiftIds={freeGiftIds}
                freeGiftProducts={freeGiftProducts}
              />
            </div>
          )}

          {isDataLoaded &&
            ((cartItems && cartItems.length <= 0) || !cartItems) && (
              <div
                className={`cart-empty ${cartItems?.length === 0 ? "active" : ""
                  }`}
              >
                {t("shopingcart_emptymsg")}
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

export default Cart;
